module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// ./~/.2.4.1@core-js/library/modules/_is-object.js
// module id = 20
// module chunks = 3